export const ADD_TRANSLATIONS = 'ADD_TRANSLATIONS'
export const CHANGE_LANG = 'CHANGE_LANG'
